import React from "react";

const SubmitLoading = ({ text = "Loading...", color = "black" }) => {
  return (
    <div className="d-flex align-items-center justify-content-center w-100">
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          style={{
            margin: "auto",
            background: "none",
            display: "block",
          }}
          width="40px"
          height="40px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          {Array.from({ length: 12 }).map((_, i) => (
            <rect
              key={i}
              x="47"
              y="24"
              rx="5"
              ry="5"
              width="6"
              height="12"
              fill={color}
              style={{ opacity: 1 - i * 0.08 }}
              transform={`rotate(${i * 30} 50 50)`}
            >
              <animate
                attributeName="opacity"
                values="1;0"
                keyTimes="0;1"
                dur="1s"
                begin={`${i * 0.1}s`}
                repeatCount="indefinite"
              />
            </rect>
          ))}
        </svg>
      </div>
      <div>{text}</div>
    </div>
  );
};

export default SubmitLoading;
